import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "納品数", enum: "PURCHASE_QUANTITY" },
  { value: 2, text: "納品予定日", enum: "DELIVERY_TIME" },
  { value: 3, text: "分納", enum: "INSTALLMENT" },
]);
